import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { Constants } from '@constants'
import { AuthService } from '@shared-services/auth.service'
import { getTvReturnUrl, tvReturnQueryParams } from '../auth/tv-return-url'
import { TvEntryContext } from '../auth/tv-entry-context'

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService)
  const router = inject(Router)
  if (inject(TvEntryContext).resolve(state.url ?? '/', _route.queryParams?.['returnUrl']) === 'ENTRY') return router.createUrlTree(['/tv'])

  const returnUrl = getTvReturnUrl(state.url) ?? getTvReturnUrl(_route.queryParams?.['returnUrl'])
  const queryParams = tvReturnQueryParams(returnUrl)
  const redirect = (path: string) => router.createUrlTree([path], queryParams ? { queryParams } : undefined)

  if (!auth.isAuthenticated()) return redirect('/iniciar-sesion')

  const currentUrl = state.url?.split('?')[0] || '/'
  if (auth.requiresPasswordChange() && currentUrl !== Constants.routes.MANDATORY_PASSWORD_CHANGE) {
    return redirect(Constants.routes.MANDATORY_PASSWORD_CHANGE)
  }

  if (
    auth.requiresLegalConsent()
    && currentUrl !== Constants.routes.LEGAL_CONSENT
    && currentUrl !== Constants.routes.MANDATORY_PASSWORD_CHANGE
  ) {
    return redirect(Constants.routes.LEGAL_CONSENT)
  }

  if (currentUrl === '/' && returnUrl) return router.createUrlTree([returnUrl])

  if (
    currentUrl === '/'
    && auth.hasRole('PATIENT')
    && auth.hasCapability({ resourceCode: 'PATIENT_OVERVIEW', action: 'view' })
  ) {
    return router.createUrlTree(['/patient-portal'])
  }

  return true
}
